import { SearchResultCustomer } from '../models/shared/SearchResults'
import { useText } from '../context/TextContext'
import { PATHS } from '../utils/shared/constants'
import { Link } from 'react-router-dom'
import CustomerName from './CustomerName'

interface Props {
    hits: SearchResultCustomer[]
}

export default function SearchCustomersResults(props: Props) {
    const text = useText();

    if (props.hits.length === 0) {
        return <div>
            <h6>{text.customers}</h6>
            <div className='text-muted '>{text.noResults}</div>
        </div>
    }

    const renderContact = (customerResult: SearchResultCustomer) => {
        let parts = [];
        if (customerResult.email) {
            parts.push(<div className='d-flex gap-2'>
                <i className='bi bi-envelope-fill' />
                <div>{customerResult.email}</div>
            </div>);
        }

        if (customerResult.phone) {
            parts.push(<div className='d-flex gap-2'>
                <i className='bi bi-telephone-fill' />
                <div>{customerResult.phone}</div>
            </div>)
        }

        return <div className='d-flex gap-3'>
            {parts}
        </div>
    }

    return (<div>

        <h6>{text.customers}</h6>
        <div className='d-flex flex-column gap-2 '>
            {props.hits.map((result, index) => <Link to={`${PATHS.CUSTOMERS}/${result.objectID}`} key={index}>
                <div>
                    <CustomerName customer={result} />
                    <p className='m-0 small text-muted'>{renderContact(result)}</p>
                </div>
            </Link>

            )}
        </div>
    </div>
    )
}
